import {mapActions, mapGetters} from 'vuex'

export const profileMixin = {
  computed: {
    ...mapGetters({
      'user': 'profile/user'
    })
  },
  methods: {
    ...mapActions({
      'getCurrentUser': 'profile/getProfileUser'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/profileMixin.js